import React from "react";

import { Box } from "@braze/beacon-core";

import { ListItemLogo, StyledHeading, StyledBodyText, StyledFlexBox } from "./RegistrationListItem.styles";
import type { RegistrationListItemProps } from "./types";

export const RegistrationListItem = ({ header, description, logo }: RegistrationListItemProps) => {
  return (
    <StyledFlexBox>
      <ListItemLogo src={logo} />
      <Box>
        <StyledHeading level={2}>{header}</StyledHeading>
        <StyledBodyText>{description}</StyledBodyText>
      </Box>
    </StyledFlexBox>
  );
};
